import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import type { EmarRound } from '../types/emarMedicationRounds'

export const EMAR_ROUNDS_QUERY_KEY = 'emar-medication-rounds'

interface MedicationRoundsReportData {
  rounds: EmarRound[]
  prnAvailableTotal: number
}

export const useMedicationRoundsReport = (date: string) => {
  return useQuery<MedicationRoundsReportData>(
    [EMAR_ROUNDS_QUERY_KEY, date],
    async () => {
      const params = new URLSearchParams({ date, residentMeds: 'true' })
      const response = await getJSON({
        url: `emar/medication-administration-instances/medication-rounds-report?${params}`,
        isRota: true,
      })
      return {
        rounds: response?.result ?? [],
        prnAvailableTotal: response?.prnAvailableTotal ?? 0,
      }
    },
    {
      staleTime: 2 * 60 * 1000,
      keepPreviousData: true,
      enabled: !!date,
    }
  )
}
